import React, { useState, useEffect } from "react";
import Adminsidebar from "../components/Adminsidebar";
import Adminheader from "../components/Adminheader";
import Uppercase from "../components/Uppercase";
import axios from "axios";
import { FaEdit, FaTrashAlt, FaDownload, FaUpload } from "react-icons/fa";
import * as xlsx from "xlsx";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { useYearContext } from "../components/YearContext";

const Adminleads = () => {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const openSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  const { yearSelected } = useYearContext();

  const formatDateTime = (dateTime) => new Date(dateTime).toLocaleString();
  const [employeeData, setEmployeeData] = useState([]);
  const fileInputRef = React.useRef(null);

  useEffect(() => {
    const fetchEmployeeData = async () => {
      try {
        const response = await axios.get(
          "https://api.easytaxexperts.com/api/getemployeess"
        );
        setEmployeeData(response.data);
      } catch (error) {
        console.error("Error fetching employee data:", error);
      }
    };
    fetchEmployeeData();
  }, []);

  const handleUploadItems = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const readExcel = async (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = xlsx.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const excelData = xlsx.utils.sheet_to_json(sheet);
      try {
       await axios.post("https://api.easytaxexperts.com/leads/upload/excel", {
          data: excelData,
        });
        toast.success("Data Inserted successfully");
        setDocuments((prevData) => [...prevData, ...excelData]);

      } catch (error) {
        console.error("Error uploading Excel data:", error);
      }
    };
    reader.readAsArrayBuffer(file);
  };

  const handleonExport = () => {
    var wb = xlsx.utils.book_new(),
      ws = xlsx.utils.json_to_sheet(documents);

    xlsx.utils.book_append_sheet(wb, ws, "MySheet1");
    xlsx.writeFile(wb, "MyExcel.xlsx");
  };

  const [selectedRows1, setSelectedRows1] = useState([]);
  const [checkAll, setCheckAll] = useState(false);

  const handleCheckboxChangeid = (id) => {
    const isSelected = selectedRows1.includes(id);
    const updatedSelection = isSelected
      ? selectedRows1.filter((rowId) => rowId !== id)
      : [...selectedRows1, id];

    setCheckAll(updatedSelection.length === records.length);
    setSelectedRows1(updatedSelection);
  };

  const handleCheckAll = () => {
    if (checkAll) {
      setSelectedRows1([]);
    } else {
      setSelectedRows1(records.map((record) => record.id));
    }
    setCheckAll(!checkAll);
  };

  const handleOkClick = () => {
    if (selectedRows1.length === 0 || selectedEmployees === "") {
      toast.warn("Please select at least one client and one employee.");
      return;
    }
    handleAssignEmployee();
  };
  const [documents, setDocuments] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState("");
  useEffect(() => {
    fetchDocuments(); // Fetch documents when the component mounts
  }, []);

  const fetchDocuments = async () => {
    try {
      const response = await axios.get("https://api.easytaxexperts.com/leads");
      setDocuments(response.data);
    } catch (error) {
      console.error("Error fetching documents:", error);
    }
  };

  const handleEmployeeChange = (employee) => {
    setSelectedEmployees(employee.id);
  };

  const handleAssignEmployee = async () => {
    try {
      const response = await axios.put("https://api.easytaxexperts.com/updateleads", {
        selectedRows1,
        selectedEmployees,
      });
      if (response.data.success) {
        toast.success("The values updated successfully");
        window.location.reload();
      
      }
    } catch (error) {
      console.log(error);
    }
  };

  //filters
  const [filters, setFilters] = useState({
    dateFrom: "",
    dateTo: "",
    clientName: "",
    status: "",
  });

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const filterDocuments = documents.filter((doc) => {
    const { dateFrom, dateTo, clientName, status } = filters;
    const lowerCaseStatus = status.toLowerCase();
    const documentDate = doc.created_at ? doc.created_at.substring(0, 10) : "";
    const fromDate = dateFrom ? dateFrom : "";
    const toDate = dateTo ? dateTo : new Date().toISOString().substring(0, 10);

    const nextYear = (parseInt(yearSelected) + 1).toString();
    const startDate = `${parseInt(nextYear) - 1}-09-01`;
    const endDate = `${nextYear}-08-31`;

    return (
      documentDate >= startDate &&
      documentDate <= endDate &&
      (dateFrom === "" || documentDate >= fromDate) &&
      (dateTo === "" || documentDate <= toDate) &&
      (clientName === "" ||
        doc.client_name.toLowerCase().includes(clientName.toLowerCase())) &&
      (status === "" || doc.status.toLowerCase() === lowerCaseStatus)
    );
  });

  const reversedDocuments = filterDocuments.slice().reverse();

  //pagination
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 100;
  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;
  const records = reversedDocuments.slice(firstIndex, lastIndex);
  const npage = Math.ceil(filterDocuments.length / recordsPerPage);
  const numbers = [...Array(npage + 1).keys()].slice(1);

  const prePage = () => {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const changeCpage = (id) => {
    setCurrentPage(id);
  };
  const nextPage = () => {
    if (currentPage !== npage) {
      setCurrentPage(currentPage + 1);
    }
  };

  const [formdata, setFormdata] = useState({
    status: "",
    comments: "",
  });

  const handleChange = (e) => {
    setFormdata((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.put(
        `https://api.easytaxexperts.com/editlead/${editID}`,
        formdata
      );

      if (response && response.data && response.data.success) {
        toast.success("Lead updated successfully");
        window.location.reload();

        setFormdata({
          status: "",
          comments: "",
        });
      } else {
        toast.error("Failed to update lead");
      }
    } catch (error) {
      console.error("Error updating lead:", error);
      toast.error("An error occurred while updating the lead.");
    }
  };

  const [editID, setEditID] = useState("");
  const handleEdit = (id, status, comments) => {
    setEditID(id);
    setFormdata({
      status: status,
      comments: comments,
    });
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      position: "top",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      customClass: {
        popup: "swal-custom-height", // Apply custom class here
      },
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`https://api.easytaxexperts.com/delete/lead/${id}`)
          .then(() => {
            toast.success("lead deleted Successfully");
            window.location.reload();
          })
          .catch((err) => {
            toast.error("Error deleting lead");
            console.log(err);
          });
      }
    });
  };

  const handleSelecteddelete = async() => {
try{
  console.log(selectedRows1);
  const response = await axios.delete("https://api.easytaxexperts.com/delete/selectedleads", {data: { selectedRows1 } });
  if(response.data.success){
    toast.success("Selected leads deleted successfully");
    window.location.reload();
  }

}catch(error){
  console.log(error);
}
  }

  return (
    <div>
      <Uppercase />
      <div className="invoice-grid-container">
        <Adminheader openSidebar={openSidebar} />
        <Adminsidebar
          openSidebarToggle={openSidebarToggle}
          openSidebar={openSidebar}
        />
        <main className="main-container mt-2">
          <div className="container">
          <div
  className="row mt-2"
  style={{
    fontSize: "12px", // Smaller text size
   
    marginBottom: "5px",
  }}
>
              <div
    className="col-lg-12 d-flex flex-wrap align-items-center gap-2"
    style={{ rowGap: "10px" }} // Adjust spacing between elements
  >
   {/* Assign To Dropdown */}
   <div className="d-flex align-items-center gap-2">
              <div className="dropdown">
                <button
                            className="btn btn-primary btn-sm dropdown-toggle"
                  data-bs-toggle="dropdown"
                  disabled={selectedRows1.length === 0}
                >
                  Assign To ({selectedRows1.length})
                </button>

                <ul
          className="dropdown-menu"
          style={{
            maxHeight: "150px", // Reduce height
            overflowY: "auto",
            fontSize: "12px", // Smaller font size
            padding: "2px", // Minimize padding for dropdown items
          }}
        >
                <div >
                  {employeeData.map((employee, index) => (
                    <li key={index} className="dropdown-item" style={{ padding: "4px 8px" }}>
                    <div className="d-flex align-items-center gap-2">
                     
                          <input
                            type="radio"
                            value={employee.username}
                            checked={selectedEmployees === employee.id}
                            onChange={() => handleEmployeeChange(employee)}
                          />
                        
                        <div> {employee.username}</div>
                      </div>
                    </li>
                  ))}
                  </div>
                    <div className="btndiv">
                  <button
                    onClick={handleOkClick}
                    className="btn btn-primary btn-sm assignbtn"
                    style={{
              
              padding: "4px 8px",
              fontSize: "12px",
              marginLeft: "50px",
            }}

                  >
                  
                    Assign
                  </button>
                  </div>
                </ul>
              </div>
              <button className="btn btn-secondary btn-sm" onClick={handleonExport}  style={{ lineHeight: "1" }}>
                <FaDownload /> 
              </button>
              </div>


                <div >
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    name="dateFrom"
                    value={filters.dateFrom}
                    onChange={handleFilterChange}
                    style={{ minWidth: "150px" }}
                  />
                </div>


                <div >
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    name="dateTo"
                    value={filters.dateTo}
                    onChange={handleFilterChange}
                    style={{ minWidth: "150px" }}
                  />
                </div>


                <div >
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Client Name"
                    name="clientName"
                    value={filters.clientName}
                    onChange={handleFilterChange}
                    style={{ minWidth: "150px", height: "30px", padding: "5px" }}
                  />
                </div>


                <div >
                  <select
                    className="form-select form-select-sm"
                    name="status"
                    value={filters.status}
                    onChange={handleFilterChange}
                    style={{ minWidth: "150px" }}
                  >
                      <option value="" style={{ fontSize: "12px", height: "30px" }}>All Statuses</option>
    <option value="Registered" style={{ fontSize: "12px", height: "30px" }}>Registered</option>
    <option value="Callback" style={{ fontSize: "12px", height: "30px" }}>Callback</option>
    <option value="Voicemail" style={{ fontSize: "12px", height: "30px" }}>Voicemail</option>
    <option value="Wrongnumber" style={{ fontSize: "12px", height: "30px" }}>Wrong Number</option>
    <option value="Intrested" style={{ fontSize: "12px", height: "30px" }}>Interested</option>
    <option value="Not Intrested" style={{ fontSize: "12px", height: "30px" }}>Not Interested</option>
    <option value="Documentpending" style={{ fontSize: "12px", height: "30px" }}>Document Pending</option>
    <option value="Duplicate" style={{ fontSize: "12px", height: "30px" }}>Duplicate</option>
    <option value="Alreadyfiledtaxes" style={{ fontSize: "12px", height: "30px" }}>Already Filed Taxes</option>
    <option value="Documentsuploaded" style={{ fontSize: "12px", height: "30px" }}>Documents Uploaded</option>
    <option value="Preparationpending" style={{ fontSize: "12px", height: "30px" }}>Preparation Pending</option>
    <option value="Additionaldocumentpending" style={{ fontSize: "12px", height: "30px" }}>Additional Document Pending</option>
    <option value="Reviewpending" style={{ fontSize: "12px", height: "30px" }}>Review Pending</option>
    <option value="Reviewcompleted" style={{ fontSize: "12px", height: "30px" }}>Review Completed</option>
    <option value="Clientreview" style={{ fontSize: "12px", height: "30px" }}>Client Review</option>
    <option value="Paymentpending" style={{ fontSize: "12px", height: "30px" }}>Payment Pending</option>
    <option value="Paid" style={{ fontSize: "12px", height: "30px" }}>Paid</option>
    <option value="Partialpayment" style={{ fontSize: "12px", height: "30px" }}>Partial Payment</option>
    <option value="Finaldocumentsent" style={{ fontSize: "12px", height: "30px" }}>Final Document Sent</option>
    <option value="Efilingpending" style={{ fontSize: "12px", height: "30px" }}>E Filing Pending</option>
    <option value="Itindocumentssenttoclient" style={{ fontSize: "12px", height: "30px" }}>ITIN Documents Sent to Client</option>
    <option value="Itincertificationpending" style={{ fontSize: "12px", height: "30px" }}>ITIN Certification Pending</option>
    <option value="Statefilingpending" style={{ fontSize: "12px", height: "30px" }}>State Filing Pending</option>
    <option value="Filingcopypending" style={{ fontSize: "12px", height: "30px" }}>Filing Copy Pending</option>
    <option value="Filingcopyuploaded" style={{ fontSize: "12px", height: "30px" }}>Filing Copy Uploaded</option>
    <option value="Finaldrafttobeuploaded" style={{ fontSize: "12px", height: "30px" }}>Final Draft to be Uploaded</option>
    <option value="Signature8879senttoclient" style={{ fontSize: "12px", height: "30px" }}>Signature 8879 Sent to Client</option>
    <option value="Signature8879signedcopyreceived" style={{ fontSize: "12px", height: "30px" }}>Signature 8879 Signed copy Received</option>
    <option value="Signature8879yettoreceive" style={{ fontSize: "12px", height: "30px" }}>Signature 8879 Yet to Receive</option>
    <option value="Complete" style={{ fontSize: "12px", height: "30px" }}>Completed</option>
                  </select>
                </div>

                <div className="d-flex gap-2">
                <button
                  onClick={handleUploadItems}
                  type="button"
                  className="btn  btn-success "
                  style={{ lineHeight: "1" }}
                >
                  <FaUpload />
                  Upload
                </button>

                <button
                  onClick={handleSelecteddelete}
                  type="button"
                  className="btn  btn-danger "
                  style={{ lineHeight: "1" }}
                  disabled={selectedRows1.length === 0}
                >
                  <FaTrashAlt className="mb-1 me-1"/>
                  Delete
                </button>


              </div>
              </div>
             
            </div>

         



            <div className="table-container"  style={{
    height: "calc(89vh - 150px)", // Adjust the 150px based on your header/pagination height
   
    border: "1px solid #ccc",
  }}>
              <div className="table-responsive tablediv">
              <table
      className="table table-hover table-bordered"
      style={{
        fontSize: "12px", // Smaller font size
        lineHeight: "1.2", // Reduce line height for compact view
      }}
    >
                  <thead className="table-primary">
                    <tr>
                      <th style={{ padding: "5px" }}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={checkAll}
                          onChange={handleCheckAll}
                        />
                        Check All
                      </th>
                      <th style={{ padding: "5px" }}>S.No</th>
                      <th style={{ padding: "5px" }}>Lead Name</th>
                      <th style={{ padding: "5px" }}>Email</th>
                      <th style={{ padding: "5px" }}>Contact</th>
                      <th style={{ padding: "5px" }}>AlternateContact</th>
                      <th style={{ padding: "5px" }}>Status</th>
                      <th style={{ padding: "5px" }}>Assigned To</th>
                      <th style={{ padding: "5px" }}>Created At</th>
                      <th style={{ padding: "5px" }}>Assigned Date</th>
                      <th style={{ padding: "5px" }}>Comments</th>
                      <th style={{ padding: "5px" }}>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {records.map((doc, index) => (
                      <tr key={doc.id}>
                        <td>
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={selectedRows1.includes(doc.id)}
                            onChange={() => handleCheckboxChangeid(doc.id)}
                          />
                        </td>
                      <td style={{ padding: "5px" }}>{filterDocuments.length - ((currentPage - 1) * recordsPerPage + index)}</td>

                        <td style={{ padding: "5px" }}>{doc.client_name}</td>
                        <td style={{ padding: "5px" }}>{doc.email}</td>
                        <td style={{ padding: "5px" }}>{doc.contact}</td>
                        <td style={{ padding: "5px" }}>{doc.alternate_contact}</td>
                        <td style={{ padding: "5px" }}>{doc.status}</td>
                        <td style={{ padding: "5px" }}>
                          {doc.assigned_to ? doc.assigned_to : "Unassigned"}
                        </td>
                        <td style={{ padding: "5px" }}>{formatDateTime(doc.created_at)}</td>
                        <td style={{ padding: "5px" }}>{doc.assigned_date}</td>
                        <td style={{ padding: "5px" }}>{doc.comments}</td>
                        <td style={{ padding: "5px" }} className="d-flex gap-1">
                          <button
                            className="btn btn-warning btn-sm"
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModal"
                          >
                            <FaEdit
                              onClick={() =>
                                handleEdit(doc.id, doc.status, doc.comments)
                              }
                            />
                          </button>
                          <button className="btn btn-danger btn-sm">
                            <FaTrashAlt onClick={() => handleDelete(doc.id)} />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div
              class="modal fade"
              id="exampleModal"
              tabindex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">
                      Edit Lead
                    </h5>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <form onSubmit={handleSubmit}>
                    <div class="modal-body">
                      <div className="row gap-2 align-items-center">
                        <label htmlFor="status" className="col-lg-2">
                          Status
                        </label>
                        <div className="col-lg-6">
                          <select
                            className="form-select "
                            onChange={handleChange}
                            name="status"
                            value={formdata.status}
                          >
                            
                            <option value="Registered">Registered</option>
                            <option value="Callback">Callback</option>
                            <option value="Voicemail">Voicemail</option>
                            <option value="Wrongnumber">Wrong Number</option>
                            <option value="Intrested">Intrested</option>
                            <option value="Not Intrested">Not Intrested</option>
                            <option value="Documentpending">
                              Document Pending
                            </option>
                            <option value="Duplicate">Duplicate</option>
                            <option value="Alreadyfiledtaxes">
                              Already Filed Taxes
                            </option>
                            <option value="Documentsuploaded">
                              Documents Uploaded{" "}
                            </option>
                            <option value="Preparationpending">
                              Preparation Pending
                            </option>
                            <option value="Additionaldocumentpending">
                              Additional Document Pending
                            </option>
                            <option value="Reviewpending">
                              Review Pending
                            </option>
                            <option value="Reviewcompleted">
                              Review Completed
                            </option>
                            <option value="Clientreview">Client Review</option>
                            <option value="Paymentpending">
                              Payment Pending
                            </option>
                            <option value="Paid">paid</option>
                            <option value="Partialpayment">
                              Partial Payment
                            </option>
                            <option value="Finaldocumentsent">
                              Final Document Sent
                            </option>
                            <option value="Efillingpending">
                              E Filing Pending
                            </option>
                            <option value="Itndocumentssenttoclient">
                              ITIN Documents Sent to Client
                            </option>
                            <option value="Itncertificationpending">
                              ITIN Certification Pending{" "}
                            </option>
                            <option value="Statefillingpending">
                              State Filing Pending{" "}
                            </option>
                            <option value="Filingcopypending">
                              Filing Copy Pending{" "}
                            </option>
                            <option value="Filingcopyuploaded">
                              Filing Copy Uploaded
                            </option>
                            <option value="Finaldrafttobeuploaded">
                              Final Draft to be Uploaded
                            </option>
                            <option value="Signature8879senttoclient">
                              Signature 8879_Sent to Client
                            </option>
                            <option value="Signature8879signedcopyreceived">
                              Signature 8879_Signed copy Received
                            </option>
                            <option value="Signature8879yettoreceive">
                              Signature 8879_Yet to Receive
                            </option>
                            <option value="Complete">Completed</option>
                          </select>
                        </div>
                      </div>
                      <div className="row gap-2 align-items-center mt-2">
                        <label htmlFor="comments" className="col-lg-2">
                          Comments
                        </label>
                        <div className="col-lg-6">
                          <input
                            type="text"
                            className="form-control"
                            name="comments"
                            value={formdata.comments}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal"
                      >
                        Close
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary"
                        data-bs-dismiss="modal"
                      >
                        Save
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            <nav className="mt-2">
            <ul
    className="pagination"
    style={{
      fontSize: "10px", // Reduce font size
      padding: "0", // Remove unnecessary padding
    }}
  >
                <li className="page-item">
                  <a href="#" className="page-link" onClick={prePage}  style={{
          padding: "2px 5px", // Adjust padding for smaller height
          height: "auto", // Allow height to adjust with padding
          fontSize: "12px",
        }}>
                    Prev
                  </a>
                </li>
                {numbers.map((n, i) => {
                  return (
                    <li
                      className={`page-item ${
                        currentPage === n ? "active" : ""
                      }`}
                      key={i}
                    >
                      <a
                        href="#"
                        className="page-link"
                        onClick={() => changeCpage(n)}
                        style={{
              padding: "2px 5px", // Reduce padding
              height: "auto", // Consistent height
              fontSize: "12px",
            }}
                      >
                        {n}
                      </a>
                    </li>
                  );
                })}
                <li className="page-item">
                  <a href="#" className="page-link" onClick={nextPage}
                  style={{
          padding: "2px 5px", // Same padding as above
          height: "auto", // Adjust height
          fontSize: "12px",
        }}
                  >
                    Next
                  </a>
                </li>
              </ul>
            </nav>
            <input
              type="file"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={readExcel}
              
            />
          </div>
        </main>
      </div>
    </div>
  );
};

export default Adminleads;
